import Vue from 'vue';
import { getRebornApiUrl } from '@/shared/utils/helpers';
/**
 * Client para a API do Atlas Reborn (backend NestJS).
 * O Bearer token da sessão (interceptor global do axios) é aceito pelos dois
 * backends — o reborn valida o mesmo encrypted token do legado.
 */
/**
 * Ativa uma feature flag opt-in (whitelist no backend) para a conta do
 * usuário autenticado. Usado pelo modal de introdução da nova versão (V4).
 */
export async function optInFeatureFlag(flag) {
    return Vue.axios.post(`${getRebornApiUrl()}/user/feature_flags/opt_in`, { flag });
}
